import UpdatePricingPlan from "./UpdatePricingPlan"

export default UpdatePricingPlan